import { Component, AfterViewInit, Input } from '@angular/core';

import {BemSubtipo} from "../shared/bem-subtipo.model";
import {BemSubtipoApiService} from "../shared/bem-subtipo-api.service";

@Component({
  selector: 'app-bem-subtipos-form',
  template: require('./bem-subtipos-form.component.html'),
  styles: [require('./bem-subtipos-form.component.css')]
})
export class BemSubtiposFormComponent implements AfterViewInit {
  @Input() list: BemSubtipo[] = [];

  constructor(
    private _bemSubtipoApiService: BemSubtipoApiService
  ) { }

  ngAfterViewInit() {
    if (!this.list.length) {
      this.newSubtipo();
    }
  }

  changeEnable(item: any, changedByUser?: boolean) {
    if (changedByUser) {
      if(item.ativo) {
        this.onEnable(item);
      } else {
        this.onDelete(item);
      }
    }
  }

  clickAddNew() {
    this.newSubtipo();
  }

  private newSubtipo() {
    var object: BemSubtipo = new BemSubtipo();
    object.ativo = true;
    this.list.push(object);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {

    }.bind(this));

    this._bemSubtipoApiService.onDelete(item.id, onDone);
  }

  private onEnable(item: any) {
    var onDone = (function(Response: any) {

    }.bind(this));

    var obj: any = {id: item.id, ativo: true};
    this._bemSubtipoApiService.onPut(obj, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-subtipos/bem-subtipos-form/bem-subtipos-form.component.ts
 **/